import React from 'react';
import {
  Card,
  CardHeader,
  CardBody
} from "@heroui/react";

interface ContentCardProps {
  title: string;
  content: string;
  className?: string;
  isItalic?: boolean;
  isQuote?: boolean;
}

/**
 * ContentCard - A reusable component for displaying text content
 */
export default function ContentCard({
  title,
  content,
  className = "",
  isItalic = false,
  isQuote = false
}: ContentCardProps) {
  if (!content) return null;
  
  return (
    <Card className={`shadow-sm border border-gray-200 ${className}`}>
      <CardHeader className="pb-0 px-6">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
      </CardHeader>
      <CardBody className="p-6">
        <p className={`text-gray-700 ${isItalic ? 'italic' : ''}`}>
          {isQuote ? `"${content}"` : content}
        </p>
      </CardBody>
    </Card>
  );
}